import React from 'react';

/** PENDING: confirm the support address for this product. */
const SUPPORT_EMAIL = 'help@iclcollective.com';
export function Footer() {
  return <footer className="w-full bg-rink-deep" data-id="element-120" data-mp="3ggkal1dq1o2p">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-121" data-mp="32oe11y52qfc8">
        <h3 className="font-display text-2xl font-bold text-white" data-id="element-122" data-mp="32m1aiwl92wnk">
          Figure Skating <span className="text-amber" data-id="element-123" data-mp="36ppn5toqoifo">Class Ready</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-124" data-mp="3ug3bpa847z5i">
          The 3-Lane Lesson — because one coach and three levels shouldn&apos;t
          cost you every evening of the week.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-125" data-mp="3ldkeb5n3meqn">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-white hover:underline" data-id="element-126" data-mp="3qbvm7atu2f68">
            {SUPPORT_EMAIL}
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-rink-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-127" data-mp="2ezb99xgq7640">
          Figure Skating Class Ready is an educational resource for qualified
          skating coaches. Progressions assume each skater is ready as judged by
          their coach. Follow your rink&apos;s and your governing body&apos;s
          safety rules. Not medical advice: refer any injury or pain to a health
          professional. Not affiliated with, or endorsed by, any skating
          federation, level system or program. No specific results are
          promised. © Figure Skating Class Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}